import { Grid } from '@material-ui/core';
import { VerticalTabs } from '../../../../components/Tabs/VerticalTabs/VerticalTabs.component';
import { SessionsImagesManagment } from '../SessionsImagesManagment/SessionImagesManagment.component';
import ImageZonesList from '../ImageZonesList/ImageZonesList.component';
import usePermission, { UserPermission } from '../../../../hooks/usePermission';
import { TabItem } from '../../../../components/Tabs/VerticalTabs/VerticalTabs.types';
import useDocumentTitle from '../../../../hooks/DocumentTitle/documentTitle';

interface SessionsImagesContentProps {
  sheetId: string;
  sheetSymbol: string;
  onClose: () => void;
  onCancel: () => void;
  isConfigured: boolean;
}

export const SessionsImagesContent: React.FC<SessionsImagesContentProps> = ({
  sheetId,
  sheetSymbol,
  onClose,
  onCancel,
  isConfigured,
}) => {
  const isAdminImagezoneManagePermission = usePermission(UserPermission.AdminImagezoneManage);
  const isAdminSampleExamsheetManagePermission = usePermission(UserPermission.AdminSampleExamsheetManage);

  const items: TabItem[] = [];
  useDocumentTitle('Zarządzaj strefą obrazu');

  if (isAdminImagezoneManagePermission) {
    items.push({
      label: 'Strefa obrazu',
      children: <ImageZonesList sheetId={sheetId} sheetSymbol={sheetSymbol} />,
    });
  }

  if (isAdminSampleExamsheetManagePermission) {
    items.push({
      label: 'Wzorcowy arkusz',
      children: (
        <SessionsImagesManagment sheetId={sheetId} onClose={onClose} onCancel={onCancel} isConfigured={isConfigured} />
      ),
    });
  }

  return (
    <Grid container style={{ overflowX:'auto'}}>
      <VerticalTabs items={items} style={{ width: '250px' }} />
    </Grid>
  );
};
